import type { ITabContainerProps } from './types'
import { ref, defineComponent } from 'vue'
import { isFunction } from '@/utils/is'

const Tabs = defineComponent({
  setup(props: ITabContainerProps) {
    const tabIndex = ref<number>(
      (() => {
        const initialActive = (props.tabs || []).find((t) => t.active === true)
        return Math.max(initialActive ? (props.tabs || []).indexOf(initialActive) : 0, 0)
      })()
    )

    const handleClick = (i: number) => {
      try {
        tabIndex.value = i;

        if (props.onTabClick) {
          props.onTabClick(i);
        }
      } catch (e) {
        console.error(e);
      }
    }

    return () => {
      const labelClass = 'inline-block py-3 font-medium '
      const activeClass =
        'text-primary-500 rounded-t-lg active dark:bg-gray-800 dark:text-primary-500 border-b-2 border-primary-500'
      const inactiveClass = 'rounded-t-lg hover:text-gray-600 dark:hover:text-gray-300'
      return (
        <div class='w-full h-full flex flex-col'>
          <div class={'flex flex-row items-center justify-between ' + (props.headerClass || '')}>
            <ul class="flex flex-wrap gap-4 text-sm font-semibold text-center text-gray-500  dark:border-gray-700 dark:text-gray-400">
              {(props.tabs || []).map((tab, i) => (
                <li onClick={() => handleClick(i)} class="me-2">
                  <div
                    class={[labelClass + (i === tabIndex.value ? activeClass : inactiveClass), 'cursor-pointer select-none flex items-center gap-1.5']}
                  >
                    {tab.title || tab.name || `tab-${i}`}
                    {tab.badge ? (
                      <span class="ml-1 inline-flex items-center justify-center min-w-4 h-4 px-1 text-[10px] font-semibold text-white bg-red-500 rounded-full">
                        {tab.badge}
                      </span>
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>
            {props.headerActions &&
              props.headerActions.map((action) => {
                return action.component ? <action.component /> : <></>
              })}
          </div>
          {(props.tabs || []).map(
            (tab, i) =>
              i === tabIndex.value && (
                <div class="w-full flex-1">
                  {tab.component ? (
                    isFunction(tab.component) ? (
                      <tab.component {...tab.props} />
                    ) : (
                      tab.component
                    )
                  ) : (
                    <div></div>
                  )}
                </div>
              )
          )}
        </div>
      )
    }
  }
})

Tabs.props = ['tabs', 'default', 'headerActions', 'headerClass', 'onTabClick']

export default Tabs
